import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import CustomCursor from "./components/CustomCursor";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SheetTransition from "./components/SheetTransition";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Work from "./pages/Work";
import ProjectDetail from "./pages/ProjectDetail";
import Studio from "./pages/Studio";
import Journal from "./pages/Journal";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import AdminProjectEdit from "./pages/AdminProjectEdit";
import AuthCallback from "./pages/AuthCallback";

function PublicLayout() {
  return (
    <>
      <Header />
      <main className="min-h-[70vh] bg-paper">
        <SheetTransition><Outlet /></SheetTransition>
      </main>
      <Footer />
    </>
  );
}

function AdminLayout() {
  return (
    <>
      <Header />
      <main className="min-h-[70vh] bg-paper"><Outlet /></main>
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:slug" element={<ProjectDetail />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
        </Route>
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/admin/projects/:id" element={<ProtectedRoute><AdminProjectEdit /></ProtectedRoute>} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CustomCursor />
        <AppRoutes />
        <Toaster position="bottom-center" toastOptions={{ style: { fontFamily: "IBM Plex Mono, monospace", borderRadius: 0, background: "#0E1113", color: "#F6F5F2", border: "1px solid #16403F" } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
